import React, { FunctionComponent } from 'react';
import Device from 'src/devices/device';
import cls from '../utils/classnames';
import './_styles.scss';


export type HotkeyDeviceType =  'ps4' | 'default';
export interface IHotkeyProps {
    /**
     * Type of hotkey associated to device, ej: PS4 type-a is equal to L1, in STB type-a is equals to Red
     * type-a = red, type-b = yellow, type-c = green, type-d = blue
     */
    type: 'type-a' | 'type-b' | 'type-c' | 'type-d';
    classSizeHotkey?: string;
    colorKey?: string;
}
export const Hotkey: FunctionComponent<IHotkeyProps> = props => {
    /**
     * Device type for if is it ps4 with change the style, the others devices are default
     */
    const device: HotkeyDeviceType = Device.getDevice() && Device.getDevice().getPlatform();
    const { type, classSizeHotkey, colorKey } = props;
    let hotKeyClassName = !classSizeHotkey ? `aaf_hotkey-${type}` : `aaf_hotkey-${type}-${classSizeHotkey}`;
    if (device === 'ps4') {
        hotKeyClassName = `${hotKeyClassName}-${device}`;
    }
    return <span className={cls(hotKeyClassName)} style={{backgroundColor: colorKey}}/>;
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Hotkey/index.tsx